"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: bnpl/testing/bnpl-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbnpl%2Ftesting%2Fbnpl-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.circuitBreakerStateToJSON = exports.circuitBreakerStateFromJSON = exports.GetTestUserResponse = exports.GetTestUserRequest = exports.UpdateTestUserResponse = exports.UpdateTestUserRequest = exports.ProcessInstallmentResponse = exports.ProcessInstallmentRequest = exports.SetDueAtResponse = exports.SetDueAtRequest = exports.TestBnplUserData = exports.CircuitBreakerState = void 0;
const protobufPackage = 'com.step.bnpl.testing.proto';
var CircuitBreakerState;
(function (CircuitBreakerState) {
    CircuitBreakerState["INVALID_CIRCUIT_BREAKER_STATE"] = "INVALID_CIRCUIT_BREAKER_STATE";
    CircuitBreakerState["CIRCUIT_BREAKER_OPEN"] = "CIRCUIT_BREAKER_OPEN";
    CircuitBreakerState["CIRCUIT_BREAKER_CLOSED"] = "CIRCUIT_BREAKER_CLOSED";
    CircuitBreakerState["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CircuitBreakerState || (exports.CircuitBreakerState = CircuitBreakerState = {}));
function createBaseTestBnplUserData() {
    return { circuitBreakerState: undefined };
}
exports.TestBnplUserData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.circuitBreakerState)) {
            message.circuitBreakerState = circuitBreakerStateFromJSON(object.circuitBreakerState);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.circuitBreakerState !== undefined) {
            obj.circuitBreakerState = circuitBreakerStateToJSON(message.circuitBreakerState);
        }
        return obj;
    },
    create(base) {
        return exports.TestBnplUserData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestBnplUserData();
        message.circuitBreakerState = object.circuitBreakerState ?? undefined;
        return message;
    },
};
function createBaseSetDueAtRequest() {
    return { installmentId: '', dueAtMs: '0' };
}
exports.SetDueAtRequest = {
    fromJSON(object) {
        const message = {
            installmentId: isSet(object.installmentId) ? globalThis.String(object.installmentId) : '',
            dueAtMs: isSet(object.dueAtMs) ? globalThis.String(object.dueAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.installmentId !== '') {
            obj.installmentId = message.installmentId;
        }
        if (message.dueAtMs !== '0') {
            obj.dueAtMs = message.dueAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.SetDueAtRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetDueAtRequest();
        message.installmentId = object.installmentId ?? '';
        message.dueAtMs = object.dueAtMs ?? '0';
        return message;
    },
};
function createBaseSetDueAtResponse() {
    return {};
}
exports.SetDueAtResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetDueAtResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetDueAtResponse();
        return message;
    },
};
function createBaseProcessInstallmentRequest() {
    return { installmentId: '' };
}
exports.ProcessInstallmentRequest = {
    fromJSON(object) {
        const message = {
            installmentId: isSet(object.installmentId) ? globalThis.String(object.installmentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.installmentId !== '') {
            obj.installmentId = message.installmentId;
        }
        return obj;
    },
    create(base) {
        return exports.ProcessInstallmentRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProcessInstallmentRequest();
        message.installmentId = object.installmentId ?? '';
        return message;
    },
};
function createBaseProcessInstallmentResponse() {
    return {};
}
exports.ProcessInstallmentResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ProcessInstallmentResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseProcessInstallmentResponse();
        return message;
    },
};
function createBaseUpdateTestUserRequest() {
    return { userId: '', circuitBreakerState: CircuitBreakerState.INVALID_CIRCUIT_BREAKER_STATE };
}
exports.UpdateTestUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.circuitBreakerState)) {
            message.circuitBreakerState = circuitBreakerStateFromJSON(object.circuitBreakerState);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.circuitBreakerState !== undefined &&
            message.circuitBreakerState !== CircuitBreakerState.INVALID_CIRCUIT_BREAKER_STATE) {
            obj.circuitBreakerState = circuitBreakerStateToJSON(message.circuitBreakerState);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateTestUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateTestUserRequest();
        message.userId = object.userId ?? '';
        message.circuitBreakerState = object.circuitBreakerState ??
            CircuitBreakerState.INVALID_CIRCUIT_BREAKER_STATE;
        return message;
    },
};
function createBaseUpdateTestUserResponse() {
    return {};
}
exports.UpdateTestUserResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateTestUserResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateTestUserResponse();
        return message;
    },
};
function createBaseGetTestUserRequest() {
    return { userId: '' };
}
exports.GetTestUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.GetTestUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTestUserRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseGetTestUserResponse() {
    return { user: undefined };
}
exports.GetTestUserResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.user)) {
            message.user = exports.TestBnplUserData.fromJSON(object.user);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = exports.TestBnplUserData.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.GetTestUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTestUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.TestBnplUserData.fromPartial(object.user)
            : undefined;
        return message;
    },
};
function circuitBreakerStateFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CIRCUIT_BREAKER_STATE':
            return CircuitBreakerState.INVALID_CIRCUIT_BREAKER_STATE;
        case 1:
        case 'CIRCUIT_BREAKER_OPEN':
            return CircuitBreakerState.CIRCUIT_BREAKER_OPEN;
        case 2:
        case 'CIRCUIT_BREAKER_CLOSED':
            return CircuitBreakerState.CIRCUIT_BREAKER_CLOSED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CircuitBreakerState.UNRECOGNIZED;
    }
}
exports.circuitBreakerStateFromJSON = circuitBreakerStateFromJSON;
function circuitBreakerStateToJSON(object) {
    switch (object) {
        case CircuitBreakerState.INVALID_CIRCUIT_BREAKER_STATE:
            return 'INVALID_CIRCUIT_BREAKER_STATE';
        case CircuitBreakerState.CIRCUIT_BREAKER_OPEN:
            return 'CIRCUIT_BREAKER_OPEN';
        case CircuitBreakerState.CIRCUIT_BREAKER_CLOSED:
            return 'CIRCUIT_BREAKER_CLOSED';
        case CircuitBreakerState.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.circuitBreakerStateToJSON = circuitBreakerStateToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=bnpl-testing-service.js.map